export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || 'AQZjArrSxsgLKxn-k4s3a927C2xkdsGDVDzmnicKuj-xlEdolFLqQwkjwEJ1cnvzOg28RwBM9Xkp-ZNi';
